module.exports = __webpack_public_path__ + "assets/img/3.8ecd2577.png";